import { Injectable, inject } from '@angular/core';
import { Firestore, collection, collectionData, addDoc, doc, updateDoc, deleteDoc } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

export interface ArtistStatementItem {
  frameId: string;
  frameImage: string;
  quantity: number;
  commission: number;
  total: number;
}

export interface ArtistStatement {
  id?: string;
  period: string;
  companyId: string;
  companyName: string;
  artistId: string;
  artistName: string;
  items: ArtistStatementItem[];
  totalQuantity: number;
  totalAmount: number;
  createdAt?: Date;
  isDeleted?: boolean;
  // KAN-147: automated monthly snapshots (manual statements leave these unset)
  source?: 'manual' | 'automated';
  revision?: number;
  statementNumber?: string;
  rate?: number;
  signature?: string;
  missingDataAcknowledged?: boolean;
  missingDataDevices?: string[];
  issuedAt?: Date;
  issuedBy?: string;
  emailStatus?: 'not_sent' | 'pending' | 'sent' | 'failed';
  emailReceiptId?: string;
  emailTo?: string;
  emailedAt?: Date;
  emailError?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ArtistStatementService {
  private firestore = inject(Firestore);
  private collectionName = 'artist_statements';

  getStatements(): Observable<ArtistStatement[]> {
    const col = collection(this.firestore, this.collectionName);
    return collectionData(col, { idField: 'id' }) as Observable<ArtistStatement[]>;
  }

  async addStatement(statement: ArtistStatement): Promise<any> {
    const col = collection(this.firestore, this.collectionName);
    return addDoc(col, { ...statement, createdAt: new Date() });
  }

  async updateStatement(id: string, data: Partial<ArtistStatement>): Promise<void> {
    const docRef = doc(this.firestore, this.collectionName, id);
    return updateDoc(docRef, data);
  }

  async deleteStatement(id: string): Promise<void> {
    const docRef = doc(this.firestore, this.collectionName, id);
    return updateDoc(docRef, { isDeleted: true });
  }
}
